<template>
  <div>
    <div class="mt-5 main-box no-header clearfix">
      <div class="main-box-body clearfix">
        <div class="table-responsive">
          <table class="table user-list table-bordered">
            <thead>
              <tr>
                <th
                  colspan="6"
                  class="text-center">
                  <h3>EULAs</h3>
                </th>
              </tr>
            </thead>

            <tr class="table-second-header">
              <th>
                <span>Id</span>
              </th>

              <th>
                <span>Name</span>
              </th>
              <th>
                <span>Main text (de)</span>
              </th>
              <th>
                <span>Main text (en)</span>
              </th>
            </tr>

            <tr
              v-for="(eula, index) in eulas"
              :key="index">
              <td>
                <span class="user-subhead">{{ eula.created_at }}</span>
              </td>
              <td>
                <label>{{ eula.name }}</label>
              </td>

              <td class="text-center">
                <span class="label label-default">{{ eula.mac_address }}</span>
              </td>

              <td class="text-center">
                <a
                  class="table-link"
                  @click="onDelete(eula.id)">
                  <font-awesome-icon
                    size="lg"
                    icon="trash-alt" />
                </a>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { vp } from '@/tools/helpers'
import moment from 'moment'
import store from '@/store'

export default {
  props: {
    user_id: [Number, String]
  },
  data () {
    return {
      loading: false,
      saving: false,
      eulas: [
        {
          id: null,
          name: null
        }
      ]
    }
  },
  created () {
    this.fetchAllEula()
  },
  methods: {
    async fetchAllEula () {
      // this.loading = true;
      this.eulas = await this.$get('eula/list')
      console.log('eulas list', this.eulas)
      // this.loading = false;
    },
    async onDeleteEula () {
      try {
        this.saving = true
        await this.$delete(`eula/delete` + this.eula.id)
        vp.$notify.success('Eula deleted')
      } catch (err) {
        console.log('delete task error::', err)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style scoped>
</style>
